// extracted by mini-css-extract-plugin
export var blog = "BlogItemsList-module--blog--jP56S";
export var posts = "BlogItemsList-module--posts---+9uw";